import {useMutation} from "@tanstack/react-query";
import {useTranslation} from "react-i18next";
import {toast} from "sonner";

import {TOAST_CONFIG} from "@/lib/constansts";
import {useInvalidate} from "@/src/modules/core/hooks";

import {clearRequiresProfileCompletionPending} from "../lib/claim-profile-pending";
import {residentClaimService} from "../services";
import type {ResidentClaimProfileRequest} from "../types";

export default function useResidentClaimProfile() {
  const {t} = useTranslation("resident_claim");
  const invalidateMe = useInvalidate("me");

  return useMutation({
    mutationFn: (body: ResidentClaimProfileRequest) => residentClaimService.completeProfile(body),
    onSuccess: (result) => {
      clearRequiresProfileCompletionPending();
      invalidateMe();
      toast.success(
        result.message ||
          t("toast.profile_completed"),
        TOAST_CONFIG,
      );
    },
    retry: false,
  });
}
